export default {
  Error: {
    EmailOrPhoneInvalidFormat: 'Email hoặc số điện thoại không đúng định dạng',
    EmailInactive: 'Email chưa kích hoạt',
    EmailOrPhoneNotFound: 'Email hoặc số điện thoại không tồn tại',
    PhoneInactive: 'Số điện thoại chưa kích hoạt',
    PhoneNotFound: 'Số điện thoại không tồn tại',
    EmailNotFound: 'Email không tồn tại',
    RegexPhoneNumberVNInValid: 'Số điện thoại không đúng định dạng',
    EmailInvalidFormat: 'Email không đúng định dạng',
    OTPIncorrectLimitReached: 'Bạn đã nhập sai quá số lần cho phép, vui lòng gửi lại mã để lấy mã mới',
    UserNameOrPassInvalid: 'Tên tài khoản hoặc mật khẩu không đúng.',
    UserNameNotFound: 'Tên đăng nhập không tồn tại',
    CodeIncorrect: 'Mã xác thực không chính xác',
    PasswordIsNotAllowBlank: 'Mật khẩu không được để trống',
    PhoneNumberInValid: 'Số điện thoại không hợp lệ',
    PhoneNumberIsNotActive: 'Số điện thoại chưa kích hoạt',
    EmailIsNotActive: 'Email chưa được kích hoạt',
    PhoneNumberAlreadyRegistered: 'Số điện thoại đã đăng ký',
    UserNameAlreadyRegistered: 'Tên đăng nhập đã được sử dụng',
    UserNameNotMatchRegex: 'Tên đăng nhập cần 6 đến 30 ký tự, chỉ sử dụng các chữ cái (a-z), số (0-9), và dấu chấm (.)',
    EmailAlreadyRegistered: 'Email đã đăng ký',
    NotAllowBlank: 'Không được bỏ trống',
    UserNameAndPassWordNotAllowBlank: 'Tên tài khoản và mật khẩu không được bỏ trống',
    YouHaveEnteredTheWrongPasswordMoreThanFiveTimes: 'Bạn đã nhập sai mật khẩu quá 5 lần',
    TheWrongPasswordMoreThanThreeTimes: 'Bạn đã nhập sai mật khẩu quá 3 lần',
    PasswordConfirmNotDuplicate: 'Mật khẩu không khớp',
    DidNotReceiveTheVerificationCode: 'Không nhận mã xác thực',
    CaptchaInvalid: 'Mã xác thực không đúng',
    PhoneNumberInactive: 'Số điện thoại chưa kích hoạt',
    EmailPhoneNumberOrPasswordInvalid: 'Email/Số điện thoại hoặc mật khẩu không đúng',
    ViewTutorial: 'Xem hướng dẫn',
    GoogleCaptchaInvalid: 'Xác thực người dùng thất bại. Vui lòng thử lại.',
    CaptchaScoreTooLow: 'Bạn đã nhập sai thông tin tài khoản/mật khẩu quá nhiều lần. Vui lòng thử lại sau.',
    ViewTutorialForgotPasswordInHere: 'Để lấy lại mật khẩu vui lòng nhấn <span class="text-accent-200 cursor-pointer {className}">vào đây</span> để xem hướng dẫn',
    InfoIncorrect: 'Thông tin không chính xác',
    // notify
    HasError: 'Có lỗi xảy ra',
    MisaIdConnectToOtherProvider: 'Tài khoản MISA ID đã liên kết với một tài khoản Zalo khác.'
  }
}
